module.exports = __webpack_public_path__ + "static/fork-c091206d19dd4dc2f7afd188d79800b6.png";